<script lang="ts">
	export let value: string | undefined = undefined
</script>

{#if value}
	{value}
{:else}
	<i class="text-muted">N/A</i>
{/if}
